import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import { useLocation, useNavigate } from "react-router-dom";
import { seller_All_Auction } from "../../../redux/action/auctionEvent";
import {
  NoItemsLeftInTable,
  catalogueStatus,
  convertTo12HourFormat,
  handleDateSetUp,
} from "../../../helpers/helpers";
import Paginations from "../../commanPage/pagination/Paginations";
import useFilteredEvents from "../../../helpers/filterEvents";
import CommonTableLoader from "../../loader/CommonTableLoader";

function AllEventTable({ searchData, auctionFilter }) {
  const totalNumberRow = 30;
  const isLaptop = useMediaQuery({ query: "(max-width: 1550px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [allEvent, setAllEvent] = useState([]);
  const [initialAllEventData, setInitialAllEventData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [maxPageVisited, setMaxPageVisited] = useState(1);
  const { sellerAllAuctionData, loadings } = useSelector(
    (pre) => pre.sellerAllAuction
  );
  const filteredEvents = useFilteredEvents(initialAllEventData, searchData);

  useEffect(() => {
    dispatch(seller_All_Auction(currentPage, totalNumberRow, auctionFilter));
  }, [dispatch, auctionFilter, currentPage, totalNumberRow]);

  useEffect(() => {
    if (sellerAllAuctionData) {
      setAllEvent(sellerAllAuctionData);
      setInitialAllEventData(sellerAllAuctionData);
    }
  }, [sellerAllAuctionData]);

  const memoizedAllEvent = useMemo(() => allEvent, [allEvent]);

  useEffect(() => {
    setMaxPageVisited(1);
    setCurrentPage(1);
  }, [auctionFilter]);

  useEffect(() => {
    setAllEvent(filteredEvents);
  }, [filteredEvents]);

  if (loadings) {
    return <CommonTableLoader />;
  }
  return (
    <>
      <div className="table-container-style">
        {memoizedAllEvent?.length === 0 && searchData !== "" ? (
          <NoItemsLeftInTable />
        ) : (
          <table
            className={`responsive-table centered ${isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
          >
            <thead>
              <tr>
                <th style={{ width: !isLaptop && "350px" }}>Auction ID</th>
                <th>Auction Region</th>
                <th>Description</th>
                <th>Date/Timings</th>
                <th>Catalogue status</th>
                <th>Action </th>
              </tr>
            </thead>
            <tbody>
              {memoizedAllEvent?.map((items, index) => (
                <tr key={items?.auctionId}>
                  <td style={{ width: !isLaptop && "350px" }}>
                    <span>{items?.auctionId}</span>
                    <span>
                      {items?.location?.state && !isLaptop
                        ? ` - ${items.location.state}`
                        : items.location.state}
                    </span>
                  </td>
                  <td>{items?.auctionRegion || "..."}</td>
                  <td style={{ width: !isTablet ? "250px" : "auto" }}>
                    <span className="NoOfline" style={{ WebkitLineClamp: 1 }}>
                      {items?.description || "..."}
                    </span>
                  </td>
                  <td>
                    <p>{handleDateSetUp(items?.auctionSchedule?.startDate)}</p>
                    <p>
                      {convertTo12HourFormat(
                        items?.auctionSchedule?.startingTime
                      )}{" "}
                      to{" "}
                      {convertTo12HourFormat(
                        items?.auctionSchedule?.endingTime
                      )}
                    </p>
                  </td>
                  <td
                    className={`${items?.catalogue?.industryApproval?.status === "approval"
                        ? "green-text"
                        : items?.catalogue?.industryApproval?.status ===
                          "notApproval"
                          ? "red-text"
                          : "orange-text"
                      }`}
                    style={{ width: !isTablet && "150px" }}
                  >
                    <span>
                      {catalogueStatus(
                        items?.catalogue?.industryApproval?.status
                      )}
                    </span>
                  </td>

                  <td>
                    <span
                      className="material-icons  cercle-purple-text  pointer"
                      onClick={() => {
                        if (items?.auctionType === "reverseAuctionProduct") {
                          navigate(
                            `/product-reverse-auction/single-auction/${items?._id}`
                          );
                        } else if (
                          items?.auctionType === "reverseAuctionService"
                        ) {
                          navigate(
                            `/service-reverse-auction/single-auction/${items?._id}`
                          );
                        } else {
                          navigate(`/forward-auction/single-auction/${items?._id}`);
                        }
                        localStorage.setItem("pathurl", `${location.pathname}`);
                      }}
                    >
                      visibility
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        {memoizedAllEvent?.length === 0 && searchData === "" && (
          <NoItemsLeftInTable />
        )}
      </div>
      {memoizedAllEvent?.length !== 0 && (
        <Paginations
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          totalNumberRow={totalNumberRow}
          totalData={memoizedAllEvent?.length}
          maxPageVisited={maxPageVisited}
          setMaxPageVisited={setMaxPageVisited}
        />
      )}
    </>
  );
}

export default AllEventTable;
